import type { TFunction } from 'i18next';

import type { Campaign, TEmailABTestVariation, TFlagsRecord } from '@feathr/blackbox';
import { EEmailABTestWinningMetric, EMAIL_AB_TEST_VARIATIONS } from '@feathr/blackbox';
import type { IUniversalSelectOption } from '@feathr/components';

export function isEmailABTestAvailable(flags: Partial<TFlagsRecord>, campaign: Campaign): boolean {
  return Boolean(flags.showEmailABTesting) && campaign.isMailrailSingleSend;
}

export function getEmailABTestVersionLabel(variation: TEmailABTestVariation, t: TFunction): string {
  return t('Version {{letter}}', { letter: variation.toUpperCase() });
}

export function getVariationOptions(
  t: TFunction,
): Array<IUniversalSelectOption<TEmailABTestVariation>> {
  return EMAIL_AB_TEST_VARIATIONS.map((variation) => ({
    id: variation,
    name: getEmailABTestVersionLabel(variation, t),
  }));
}

export function getWinningMetricOptions(
  t: TFunction,
): Array<IUniversalSelectOption<EEmailABTestWinningMetric>> {
  return [
    { id: EEmailABTestWinningMetric.Opens, name: t('Open rate') },
    { id: EEmailABTestWinningMetric.Clicks, name: t('Click rate') },
    { id: EEmailABTestWinningMetric.Conversions, name: t('Conversions') },
  ];
}

export function getWinningMetricHelpText(metric: EEmailABTestWinningMetric, t: TFunction): string {
  const helpTextMap: Record<EEmailABTestWinningMetric, string> = {
    [EEmailABTestWinningMetric.Clicks]: t('The version with more unique clicks wins.'),
    [EEmailABTestWinningMetric.Conversions]: t('The version with more conversions wins.'),
    [EEmailABTestWinningMetric.Opens]: t('The version with more unique opens wins.'),
  };
  return helpTextMap[metric];
}
